import axios from 'axios';

// Use Vite's import.meta.env instead of process.env
export const API_URL = import.meta.env.VITE_API_URL || 'https://api.silhouettebyneha.in/';

const api = axios.create({
  baseURL: `${API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the auth token in requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Function to handle form data uploads (for files)
export const uploadFormData = async (endpoint: string, formData: FormData, method: 'post' | 'put' | 'delete' = 'post') => {
  const token = localStorage.getItem('token');
  
  const config = {
    method,
    url: `${API_URL}api/${endpoint}`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': method === 'delete' ? 'application/json' : 'multipart/form-data',
    },
    data: method === 'delete' ? {} : formData,
  };
  
  return axios(config);
};

// Media URL helper function
export const getMediaUrl = (path: string) => {
  if (!path) return '';
  // If path already includes the API_URL, return as is
  if (path.startsWith('http')) return path;
  // Otherwise, prepend the API_URL
  return `${API_URL}${path}`;
};

// Fetch time entry reports with optional filters
export const fetchTimeEntryReports = async (params: Record<string, any> = {}) => {
  return api.get(`api/time-entries/reports`, { params });
};

export default api; 